import { RootState } from '../../store/state';

export const getProfile = (state: RootState) => state.profile;
